import type { AnnotationCommandData } from '@festina/life-general-types/life'
import type { ExcludeString } from '@festina-life/core'

import { LifeAnnotationCommand } from '../../../areas/annotation/LifeAnnotationCommand'
import type { CommandDataRecord } from '../types'

export const annotationCommands: CommandDataRecord<
  ExcludeString<AnnotationCommandData['_type']>
> = {
  AnnotationCommandData: LifeAnnotationCommand,
}
